<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tlndoP/tc-custom/9781614236108.jpg?1705026229758" alt="This image is the cover for the book Another Breed of Currituck Duck Hunters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another Breed of Currituck Duck Hunters
      </h1>
      <p class="bookDescription body article font2">
        <p>People called Currituck County a sportsman's paradise back when the skies clouded over with ducks and the waters teemed with fish. The game is more elusive these days and the hunting methods more sophisticated, but native Travis Morris shows through these stories that the thrill of it all is just as intense. From a four-year-old boy on his first hunt with his grandfather to an eighty-two-year-old woman who still loves to shoot her supper, Morris highlights both the heart and humor of the sportsman. There's a three-strand cord that will forever bind Currituck gunners: passion for the hunt, love of the outdoors and respect for the dangers of open, shallow waters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Travis Morris
      </h2>
      
      <p class="authorDescription body article">Travis Morris was born in Coinjock, North Carolina, in 1932 (in the same house his mother was born in on April 3, 1908). In 1970 he started Currituck Realty, a business he still owns forty years later. In 1971, he took people across Currituck Sound in an old gas boat and out to the beach in an old Corvair for which he paid fifty dollars. He'd written "Currituck Realty" on the side of the car with white shoe polish. He sold oceanfront lots for $12,000 that are now valued at over $1 million. In 1974, he operated Monkey Island Club and opened it to the public for the first time since its founding in 1876.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e53bfc6